import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { socketClient } from '@/api/socket';

export const useRealtimeErrors = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const socket = socketClient.getSocket();

    if (!socket) {
      return;
    }

    // Erro novo ou resolvido: só recarrega as listas; o payload não é usado.
    const handleNewError = () => {
      queryClient.invalidateQueries({ queryKey: ['errors'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'metrics'] });
    };

    const handleErrorResolved = () => {
      queryClient.invalidateQueries({ queryKey: ['errors'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'metrics'] });
    };

    socket.on('error:new', handleNewError);
    socket.on('error:resolved', handleErrorResolved);

    return () => {
      socket.off('error:new', handleNewError);
      socket.off('error:resolved', handleErrorResolved);
    };
  }, [queryClient]);
};
